import React, { useContext, useState } from "react";
import styles from "./TheEdgeBanner.module.scss";
import { Context } from "../Store";
import { isMobile } from "react-device-detect";
import ReactGA from "react-ga4";
import { StoriesAzureAPI } from "../utils/getStoriesAzureApi";

const TheEdgeBanner = () => {
  const state = React.useContext(Context);
  const [showForm, setShowForm] = useState(false);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState(""); // "" | "error"
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const trackEvent = (category, action, label = "") => {
    ReactGA.event({ category, action, label });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus("");
    setIsSubmitting(true);
    trackEvent("Edge Banner Form", "Submit Clicked");

    try {
      const payload = {
        StoryId: state.guid,
        BookingReference: state.reference,
        Name: name.trim(),
        Email: email.trim(),
      };

      // TODO: replace endpoint below with the correct one once available from backend dev
      await StoriesAzureAPI.post("https://es-stories-apim.azure-api.net/Stories/SubmitEdgeScore", payload);

      setSubmitted(true);
      setName("");
      setEmail("");
    } catch (error) {
      setStatus("error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className={styles.bannerContainer}>
        <div className={styles.bannerContent}>
          <div className={styles.bannerDrawings} aria-hidden="true">
            <img className={styles.drawingLeft1} src="/img/drawing-confetti-yellow.svg" />
            <img className={styles.drawingLeft2} src="/img/drawing-small-dot.svg" />
            <img className={styles.drawingRight1} src="/img/drawing-confetti-orange.svg" />
            <img className={styles.drawingRight2} src="/img/drawing-small-dot.svg" />
            <img className={styles.drawingRight3} src="/img/drawing-hat.svg" />
          </div>
          <img src="/img/the-edge-logo.svg" />
          {!showForm ? (
            <>
              <p>
                You've played. Now make it count.
                <br />
                <br />
                We're building a Global Leaderboard of the highest scores on The Edge.
                <br />
                <br />
                Think you're in the running? Share your Story with us for the chance to win prizes.
              </p>
              <div className={`${styles.shareBtn} shareLinkWrapper`}>
                <button className="shareLink" onClick={() => setShowForm(true)}>
                  Share with us
                </button>
              </div>
            </>
          ) : submitted ? (
            <p className={styles.successMessage}>Thanks! We'll be in touch.</p>
          ) : (
            <form className={styles.shareForm} onSubmit={handleSubmit}>
              <div className={styles.formField}>
                <label htmlFor="edge-name">Name</label>
                <input
                  id="edge-name"
                  type="text"
                  placeholder="Your name"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                  required
                />
              </div>
              <div className={styles.formField}>
                <label htmlFor="edge-email">Email</label>
                <input
                  id="edge-email"
                  type="email"
                  placeholder="Your email address"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              {status === "error" && (
                <div className={styles.error}>
                  <img src="./img/error-icon.svg" />
                  <div>Something went wrong. Please try again.</div>
                </div>
              )}
              <div className={`${styles.shareBtn} shareLinkWrapper`}>
                <button type="submit" className="shareLink" disabled={isSubmitting}>
                  {isSubmitting ? "Submitting..." : "Submit"}
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
};

export default TheEdgeBanner;
